import React from "react";
import TradesPosterBasicsDocs from "../sections/TradesPosterBasics/TradesPosterBasicsDocs";

const TradesPosterBasics = () => {
  return (
    <>
      <TradesPosterBasicsDocs />
    </>
  );
};

export default TradesPosterBasics;
